'use strict';
export class BadgeHTML {
    constructor(token) {
        this.token = token;
    }
    render() {
        const color = this.token.color || 'gray';
        return `<span class="md-badge md-badge-${color}">${this.token.value}</span>`;
    }
}
